import React, { Component } from 'react';

import {
    Spin,
    Card,
    Statistic,
} from 'antd';

import { LoadingOutlined } from '@ant-design/icons';

class Loading extends Component {
    render() {
        return (
            <div style={{ width: '100%', height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                <div><Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} /></div>
                <div style={{ marginTop: 10 }}>Loading...</div>
            </div>
        );
    }
}

export default Loading;